import './Header.scss';
import Logo from '../../assets/Logo.png';
import LogoSmall from '../../assets/logoSmall.png';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Popup from '../Popup';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const [isServicesOpen, setServicesOpen] = useState(false);
  const [isCandidatesOpen, setCandidatesOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleScroll = () => {
    // setIsMenuOpen(false);
  };

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1200);
  };

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const renderHeaderLinks = () => {
    return (
      <>
        <div className='headerLinks'>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/');
            }}
            className={cn('headerLink', window.location.pathname === '/' && 'headerLinkActive')}
          >
            Home
          </span>
          <span
            onClick={() => {
              // setIsMenuOpen(false);
              setCandidatesOpen(false);
              setServicesOpen(!isServicesOpen);
            }}
            className={cn('headerLink')}
          >
            Services
          </span>
          {isServicesOpen && (
            <div className='servicesList'>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/interim_leadership');
                }}
              >
                Interim Leadership
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/executive_leadership');
                }}
              >
                Executive Search
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/critical_access');
                }}
              >
                Critical Access, Rural & Community Hospitals
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/hospital_staffing');
                }}
              >
                Hospital Staffing Services
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/mentorship');
                }}
              >
                Mentorship & Management Consulting
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/operational_assessment');
                }}
              >
                Operational Assessment
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/survey_readiness');
                }}
              >
                Survey Readiness
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/LTC_leadership');
                }}
              >
                LTC Leadership
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/locum_tenens');
                }}
              >
                Locum Tenens Staffing Solutions
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/revenue_cycle_assessment');
                }}
              >
                Revenue Cycle Assessment
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/revenue_cycle_solutions');
                }}
              >
                Revenue Cycle Solutions
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(!isServicesOpen);
                  navigate('/revenue_cycle_consulting');
                }}
              >
                Revenue Cycle Consulting & Staffing
              </span>
            </div>
          )}
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/profiles');
            }}
            className={cn('headerLink', window.location.pathname === '/profiles' && 'headerLinkActive')}
          >
            Available Talent
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/jobs');
            }}
            className={cn('headerLink', window.location.pathname === '/jobs' && 'headerLinkActive')}
          >
            Jobs
          </span>
          <span
            onClick={() => {
              setCandidatesOpen(!isCandidatesOpen);
              setServicesOpen(false);
            }}
            className={cn(
              'headerLink',
              window.location.pathname === '/for_candidates' && 'headerLinkActive',
              window.location.pathname === '/travel_nurse' && 'headerLinkActive',
            )}
          >
            For Candidates
          </span>
          {isCandidatesOpen && (
            <div className='servicesList candidatesList'>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(false);
                  setCandidatesOpen(false);
                  navigate('/for_candidates');
                }}
              >
                Interim Leaders
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(false);
                  setCandidatesOpen(false);
                  navigate('/travel_nurse');
                }}
              >
                Travel clinicians
              </span>
              <span
                className='servicesListItem'
                onClick={() => {
                  setIsMenuOpen(false);
                  setServicesOpen(false);
                  setCandidatesOpen(false);
                  navigate('/referral');
                }}
              >
                Referral program
              </span>
            </div>
          )}
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/about');
            }}
            className={cn('headerLink', window.location.pathname === '/about' && 'headerLinkActive')}
          >
            About Us
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/blog');
            }}
            className={cn('headerLink', window.location.pathname === '/blog' && 'headerLinkActive')}
          >
            Blog
          </span>
        </div>
        <a href='tel:+19133223478' className='headerPhone'>
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <g clip-path='url(#clip0_2449_224)'>
              <path
                d='M14.665 11.28V13.28C14.6657 13.4657 14.6277 13.6494 14.5533 13.8196C14.479 13.9897 14.3699 14.1424 14.233 14.2679C14.0962 14.3934 13.9347 14.489 13.7588 14.5485C13.5829 14.608 13.3966 14.63 13.2117 14.6133C11.1602 14.3904 9.18966 13.6894 7.45833 12.5667C5.84755 11.5431 4.48189 10.1774 3.45833 8.56667C2.33165 6.82747 1.63049 4.84733 1.41166 2.78667C1.395 2.60231 1.41691 2.41651 1.47599 2.24108C1.53508 2.06566 1.63004 1.90446 1.75484 1.76775C1.87964 1.63103 2.03153 1.5218 2.20086 1.44701C2.37018 1.37222 2.55322 1.33351 2.73833 1.33333H4.73833C5.06187 1.33015 5.37552 1.44472 5.62084 1.65569C5.86615 1.86666 6.02638 2.15963 6.07166 2.48C6.15608 3.12004 6.31263 3.74848 6.53833 4.35333C6.62802 4.59195 6.64744 4.85127 6.59427 5.10059C6.5411 5.3499 6.41757 5.57874 6.23833 5.76L5.39166 6.60667C6.3407 8.2757 7.72263 9.65763 9.39166 10.6067L10.2383 9.76C10.4196 9.58076 10.6484 9.45723 10.8977 9.40406C11.1471 9.35089 11.4064 9.3703 11.645 9.46C12.2498 9.6857 12.8783 9.84225 13.5183 9.92667C13.8422 9.97235 14.1379 10.1355 14.3494 10.385C14.5608 10.6345 14.6731 10.953 14.665 11.28Z'
                stroke='#3D424B'
                stroke-width='1.3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_2449_224'>
                <rect width='16' height='16' fill='white' />
              </clipPath>
            </defs>
          </svg>
          913-322-2245
        </a>
        <span
          className='headerContact'
          onClick={() => {
            setIsPopupOpen(true);
            setIsMenuOpen(false);
          }}
        >
          Send Request
        </span>
      </>
    );
  };

  return (
    <div className='header'>
      <div className='headerContent'>
        <div className='headerLogo' onClick={() => navigate('/')}>
          <img src={isMobile ? LogoSmall : Logo} alt='Logo' />
        </div>
        {isMobile ? (
          <div className='headerMobileDetails'>
            <a href='tel:+19133223478' className='headerPhone'>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clip-path='url(#clip0_2449_224)'>
                  <path
                    d='M14.665 11.28V13.28C14.6657 13.4657 14.6277 13.6494 14.5533 13.8196C14.479 13.9897 14.3699 14.1424 14.233 14.2679C14.0962 14.3934 13.9347 14.489 13.7588 14.5485C13.5829 14.608 13.3966 14.63 13.2117 14.6133C11.1602 14.3904 9.18966 13.6894 7.45833 12.5667C5.84755 11.5431 4.48189 10.1774 3.45833 8.56667C2.33165 6.82747 1.63049 4.84733 1.41166 2.78667C1.395 2.60231 1.41691 2.41651 1.47599 2.24108C1.53508 2.06566 1.63004 1.90446 1.75484 1.76775C1.87964 1.63103 2.03153 1.5218 2.20086 1.44701C2.37018 1.37222 2.55322 1.33351 2.73833 1.33333H4.73833C5.06187 1.33015 5.37552 1.44472 5.62084 1.65569C5.86615 1.86666 6.02638 2.15963 6.07166 2.48C6.15608 3.12004 6.31263 3.74848 6.53833 4.35333C6.62802 4.59195 6.64744 4.85127 6.59427 5.10059C6.5411 5.3499 6.41757 5.57874 6.23833 5.76L5.39166 6.60667C6.3407 8.2757 7.72263 9.65763 9.39166 10.6067L10.2383 9.76C10.4196 9.58076 10.6484 9.45723 10.8977 9.40406C11.1471 9.35089 11.4064 9.3703 11.645 9.46C12.2498 9.6857 12.8783 9.84225 13.5183 9.92667C13.8422 9.97235 14.1379 10.1355 14.3494 10.385C14.5608 10.6345 14.6731 10.953 14.665 11.28Z'
                    stroke='#3D424B'
                    stroke-width='1.3'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_2449_224'>
                    <rect width='16' height='16' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              913-322-2245
            </a>
            <span
              className='headerContact'
              onClick={() => {
                setIsPopupOpen(true);
                setIsMenuOpen(false);
              }}
              style={{ marginRight: '14px' }}
            >
              Request
            </span>
            <span className='headerMenu' onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? (
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M18 6L6 18' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                  <path d='M6 6L18 18' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                </svg>
              ) : (
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path d='M3 12H21' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                  <path d='M3 6H21' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                  <path d='M3 18H21' stroke='#8C8B9A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                </svg>
              )}
            </span>
          </div>
        ) : (
          renderHeaderLinks()
        )}
      </div>
      {isMenuOpen && <div className='phoneHeaderMenu'>{renderHeaderLinks()}</div>}
      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}
    </div>
  );
};

export default Header;
